export const FAILED = 'Mfa/Totp/failed';
export const SUCCESS = 'Mfa/Totp/success';
export const LOADING = 'Mfa/Totp/loading';
export const RESET = 'Mfa/Totp/reset';
export const SET_COUNT_TIME = 'Mfa/Totp/setCountTime';
